import React from "react";
import {observer} from "mobx-react";
import {ComponentPropsFromRoute} from "../../../../../routers/routers";
import {Col, Row, Typography} from "antd";
import {AgentDataAgentAccount} from "./agent.data.agent.account";
import {AgentDataAgentAgent} from "./agent.data.agent.agent";
import {useTranslate} from "../../../../../hooks/translate.hook";

export const AgentDataAgent: React.FC<ComponentPropsFromRoute> = observer(() => {
    const t = useTranslate();

    return (
        <>
            <Typography.Title level={3}>
                {t("GENERAL", {defaultValue: "General"})}
            </Typography.Title>
            <Row gutter={[16, 16]} align="top">
                <Col xs={24} md={12}>
                    <AgentDataAgentAgent />
                </Col>
                <Col xs={24} md={12}>
                    <AgentDataAgentAccount />
                </Col>
            </Row>
        </>
    );
});
